'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _playerMethods = require('../constants/playerMethods');

var _playerMethods2 = _interopRequireDefault(_playerMethods);

var _debugger = require('../../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = _playerMethods2.default.on,
    off = _playerMethods2.default.off,
    preload = _playerMethods2.default.preload,
    init = _playerMethods2.default.init,
    load = _playerMethods2.default.load,
    play = _playerMethods2.default.play,
    seek = _playerMethods2.default.seek,
    pause = _playerMethods2.default.pause,
    stop = _playerMethods2.default.stop,
    unload = _playerMethods2.default.unload,
    destroy = _playerMethods2.default.destroy,
    setVolume = _playerMethods2.default.setVolume,
    getVolume = _playerMethods2.default.getVolume,
    setTitle = _playerMethods2.default.setTitle,
    getTimes = _playerMethods2.default.getTimes,
    requestInstreamAds = _playerMethods2.default.requestInstreamAds;

var Player = function (_EventEmitter) {
  (0, _inherits3.default)(Player, _EventEmitter);

  function Player(playerName) {
    (0, _classCallCheck3.default)(this, Player);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Player.__proto__ || (0, _getPrototypeOf2.default)(Player)).call(this));

    _this.name = playerName;
    return _this;
  }

  (0, _createClass3.default)(Player, [{
    key: on,
    value: function value() {
      throw new Error(on + ' must be defined on Player instance');
    }
  }, {
    key: off,
    value: function value() {
      throw new Error(off + ' must be defined on Player instance');
    }
  }, {
    key: preload,
    value: function value() {
      _debugger2.default.log(preload + ' not defined for Player instance');
    }
  }, {
    key: init,
    value: function value() {
      _debugger2.default.log(init + ' not defined for Player instance');
    }
  }, {
    key: load,
    value: function value() {
      throw new Error(load + ' must be defined on Player instance');
    }
  }, {
    key: play,
    value: function value() {
      throw new Error(play + ' must be defined on Player instance');
    }
  }, {
    key: seek,
    value: function value() {
      _debugger2.default.log(seek + ' not defined for Player instance');
    }
  }, {
    key: pause,
    value: function value() {
      throw new Error(pause + ' must be defined on Player instance');
    }
  }, {
    key: stop,
    value: function value() {
      throw new Error(stop + ' must be defined on Player instance');
    }
  }, {
    key: unload,
    value: function value() {
      throw new Error(unload + ' must be defined on Player instance');
    }
  }, {
    key: destroy,
    value: function value() {
      throw new Error(destroy + ' must be defined on Player instance');
    }
  }, {
    key: setVolume,
    value: function value() {
      throw new Error(setVolume + ' must be defined on Player instance');
    }
  }, {
    key: getVolume,
    value: function value() {
      throw new Error(getVolume + ' must be defined on Player instance');
    }
  }, {
    key: setTitle,
    value: function value() {
      throw new Error(setTitle + ' must be defined on Player instance');
    }
  }, {
    key: getTimes,
    value: function value() {
      throw new Error(getTimes + ' must be defined on Player instance');
    }
  }, {
    key: requestInstreamAds,
    value: function value() {
      _debugger2.default.log(requestInstreamAds + ' not defined for Player instance');
    }
  }]);
  return Player;
}(_events2.default);

exports.default = Player;
//# sourceMappingURL=Player.js.map